import styles from "./Labels.module.css";

const DataLabel = ({ title, text }) => {
  return (
    <div className={styles.dataDiv}>
      {title && <p className={styles.dataDivCol1}>{title}</p>}
      {text && <p className={styles.dataDivCol2}>{text}</p>}
    </div>
  );
};

export default DataLabel;
